export var sortHearingItems = function (items) {
    return items.slice().sort(function (left, right) { return left.order - right.order; });
};
export var buildHearingAnswerMap = function (answers, items) {
    if (items === void 0) { items = []; }
    var itemsById = new Map(items.map(function (item) { return [item.id, item]; }));
    var map = {};
    answers.forEach(function (answer) {
        var item = itemsById.get(answer.publicHearingItemId);
        var jsonValue = answer.jsonValue || [];
        if ((item === null || item === void 0 ? void 0 : item.type) === "select_unique") {
            map[answer.publicHearingItemId] = jsonValue[0] || "";
            return;
        }
        if ((item === null || item === void 0 ? void 0 : item.type) === "select_multiple") {
            map[answer.publicHearingItemId] = jsonValue;
            return;
        }
        if (jsonValue.length > 0) {
            map[answer.publicHearingItemId] = jsonValue;
            return;
        }
        map[answer.publicHearingItemId] = answer.value || "";
    });
    return map;
};
export var buildHearingAnswersPayload = function (items, answers) {
    return items.flatMap(function (item) {
        var answer = answers[item.id];
        if (item.type === "text") {
            var value = typeof answer === "string" ? answer.trim() : "";
            if (!value) {
                return [];
            }
            return [{ publicHearingItemId: item.id, value: value }];
        }
        if (item.type === "select_unique") {
            if (!answer || Array.isArray(answer)) {
                return [];
            }
            return [
                {
                    publicHearingItemId: item.id,
                    jsonValue: [String(answer)],
                },
            ];
        }
        var jsonValue = Array.isArray(answer) ? answer : [];
        if (jsonValue.length === 0) {
            return [];
        }
        return [{ publicHearingItemId: item.id, jsonValue: jsonValue }];
    });
};
export var isHearingAnswerEmpty = function (answer) {
    if (Array.isArray(answer)) {
        return answer.length === 0;
    }
    return !String(answer || "").trim();
};
export var findMissingRequiredHearingItems = function (items, answers) {
    return items.filter(function (item) { return item.isRequired && isHearingAnswerEmpty(answers[item.id]); });
};
export var validateRequiredHearingAnswers = function (items, answers) {
    var missing = findMissingRequiredHearingItems(items, answers)[0];
    if (!missing) {
        return null;
    }
    return "A pergunta \"".concat(missing.description, "\" \u00E9 obrigat\u00F3ria.");
};
export var canContributeToHearing = function (status) {
    return status === "available";
};
export var canShowHearingResults = function (status) {
    return status === "awaiting_recording" ||
        status === "awaiting_minutes" ||
        status === "finished";
};
export var formatHearingAnswerDisplay = function (item, answer) {
    if (item.type === "text") {
        var value = typeof answer === "string" ? answer.trim() : "";
        return value || "—";
    }
    var selectedValues = Array.isArray(answer)
        ? answer
        : answer
            ? [String(answer)]
            : [];
    if (selectedValues.length === 0) {
        return "—";
    }
    var options = item.publicHearingItemOptions || [];
    return selectedValues
        .map(function (value) {
        var option = options.find(function (entry) { return entry.value === value; });
        return (option === null || option === void 0 ? void 0 : option.label) || value;
    })
        .join(", ");
};
